<template>
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" v-bind="$attrs">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>
